import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Options from "../entities/option";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "./list-mutations";

interface OptionsState
  extends ListState<Options> {
  options: Options;
}
class OptionsModule extends ListModule<
  OptionsState,
  any,
  Options
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Options>(),
    loading: false,
    loadingTable:false,
    sorting:'',
    order:'desc',
  };
  actions = {
    async update(
      context: ActionContext<Options, any>,
      payload: any
    ) {
      await Ajax.put(
        "/api/services/app/Configuration/UpdateSettings",
        payload.data
      );
    },
    async isFtpActive(
      context: ActionContext<Options, any>,
      payload: any
    ) {
      await Ajax.post(
        "/api/services/app/Settings/IsFtpActive?active="+payload.data.active
      );
    },
    async getOptions(
      context: ActionContext<Options, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Configuration/GetOptions"
      );
      return reponse.data.result as any;
    },
    async getValue(
      context: ActionContext<Options, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Configuration/GetValueByName?name="+payload.data.name
      );
      return reponse.data.result as any;
    },
    async getIntValue(
      context: ActionContext<Options, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Configuration/GetIntValueByName?name="+payload.data.name
      );
      return reponse.data.result as any;
    }
  };
}
const optionsModule = new OptionsModule();
export default optionsModule;
